
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education/author/[slug]",
      function () {
        return require("private-next-pages/education/author/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education/author/[slug]"])
      });
    }
  